/* "Vi guider" on big collections (snippets/collection-quiz-card.liquid), after Matas: Start opens a dialog with one
   question at a time; every answer is one of the collection's filter values, and "Se dit resultat" filters the grid in
   place (the filter bar's own update, with an address of its own for Back) and says how many fit. If that would leave
   no products, the last answers are dropped one by one (certification, fragrance-free, then skin type) until something
   is left, so the test never ends on an empty page. The answers are the shared answer component (component-answer.css). */
if (!customElements.get("collection-quiz")) {
  // Back after a quiz result: the filter bar keeps no history of its own, so the grid follows the address here.
  window.addEventListener("popstate", () => {
    if (!CollectionQuiz.pushed) return;
    const filtering = document.querySelector("storefront-filtering");
    if (filtering) filtering.renderItems(location.href);
    else location.reload();
  });

  class CollectionQuiz extends HTMLElement {
    connectedCallback() {
      // Liquid hands filter labels and values over HTML-encoded ("Fine linjer &amp; rynker"); the filter wants them plain.
      const plain = (s) => { const t = document.createElement("textarea"); t.innerHTML = s; return t.value; };
      this.steps = JSON.parse(this.querySelector("[data-quiz-steps]").textContent);
      this.steps.forEach((step) => step.options.forEach((o) => { o.label = plain(o.label); o.value = plain(o.value); }));
      this.dialog = this.querySelector("[data-quiz-dialog]");
      this.next = this.querySelector("[data-quiz-next]");
      this.querySelectorAll("[data-quiz-start]").forEach((b) => b.addEventListener("click", () => this.start()));
      this.querySelector("[data-quiz-close]").addEventListener("click", () => this.dialog.close());
      this.querySelector("[data-quiz-back]").addEventListener("click", () => this.back());
      this.next.addEventListener("click", () => this.forward());
      // A tap on the backdrop closes it.
      this.dialog.addEventListener("click", (e) => { if (e.target === this.dialog) this.dialog.close(); });
      // Closing ends the run: the page unlocks and a result still loading does not navigate any more.
      this.dialog.addEventListener("close", () => this.stop());
    }

    // The quiz can leave the page while open (filtering swaps the product grid it sits in): release the lock then too.
    disconnectedCallback() {
      this.stop();
    }

    stop() {
      document.documentElement.classList.remove("quiz-open");
      this.run = (this.run || 0) + 1;
    }

    start() {
      this.stop();
      this.answers = [];
      this.index = 0;
      this.render();
      this.dialog.showModal();
      // The page stays put behind the dialog (iPhone scrolled it on a swipe; the theme scrolls the body).
      document.documentElement.classList.add("quiz-open");
    }

    render() {
      const step = this.steps[this.index];
      this.querySelector("[data-quiz-q]").textContent = step.q;
      this.querySelector("[data-quiz-progress]").style.width = `${((this.index + 1) / this.steps.length) * 100}%`;
      this.querySelector("[data-quiz-count]").textContent = `${this.index + 1}/${this.steps.length}`;
      const box = this.querySelector("[data-quiz-options]");
      box.classList.toggle("answers--list", !!step.list);
      box.replaceChildren(...step.options.map((o, i) => {
        const b = document.createElement("button");
        b.type = "button";
        b.className = "answer";
        const label = document.createElement("span");
        label.textContent = o.label;
        b.append(label);
        b.setAttribute("aria-pressed", String(this.answers[this.index] === i));
        b.addEventListener("click", () => {
          this.answers[this.index] = i;
          box.querySelectorAll(".answer").forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
          this.next.disabled = false;
        });
        return b;
      }));
      this.next.disabled = this.answers[this.index] === undefined;
      const last = this.index === this.steps.length - 1;
      this.next.classList.toggle("control", !last);
      this.next.classList.toggle("answer-next", !last);
      this.next.classList.toggle("btn-cta-green", last);
      this.next.classList.toggle("btn-size-2", last);
      this.next.querySelector("[data-quiz-next-label]").textContent = last ? this.next.dataset.result : this.next.dataset.next;
      this.querySelector("[data-quiz-back]").hidden = this.index === 0;
    }

    back() {
      if (this.index > 0) { this.index -= 1; this.render(); }
    }

    forward() {
      if (this.index < this.steps.length - 1) { this.index += 1; this.render(); return; }
      this.finish();
    }

    // The chosen filters, most important first: what to fix, skin type, fragrance-free, certification.
    params() {
      const list = [];
      this.steps.forEach((step, i) => {
        const o = step.options[this.answers[i]];
        if (o && o.value) list.push([step.param, o.value]);
      });
      return list;
    }

    url(list) {
      const q = new URLSearchParams();
      list.forEach(([k, v]) => q.append(k, v));
      const s = q.toString();
      return s ? `${this.dataset.url}?${s}` : this.dataset.url;
    }

    // How many products a filtered address holds: the grid section alone (its paginate total), not the whole page.
    async count(url) {
      const area = document.querySelector("paginate-area");
      try {
        const html = await window.ec.sectionFetch(url, area.dataset.id);
        const doc = new DOMParser().parseFromString(html, "text/html");
        const config = doc.querySelector("[paginate-area-config]");
        const total = config ? Number(JSON.parse(config.textContent).items) : NaN;
        return Number.isFinite(total) ? total : doc.querySelectorAll("[data-paginate-main] > li [data-product-id]").length;
      } catch (e) {
        return -1; // unknown: go anyway
      }
    }

    async finish() {
      this.next.disabled = true;
      const run = this.run;
      let list = this.params();
      let found = await this.count(this.url(list));
      // Drop answers from the end (least important) while the result would be empty; keep at least the first.
      while (list.length > 1 && found === 0 && run === this.run) {
        list = list.slice(0, -1);
        found = await this.count(this.url(list));
      }
      if (run !== this.run) return; // closed or restarted meanwhile
      const url = this.url(list);
      const filtering = document.querySelector("storefront-filtering");
      const grid = document.querySelector("[data-paginate-main]");
      if (!filtering || !grid || typeof filtering.addFilter !== "function") {
        window.location.href = url;
        return;
      }
      const line = found > 0 ? (found === 1 ? this.dataset.foundOne : this.dataset.foundMany || "").replace("[count]", found) : "";
      this.dialog.close();
      CollectionQuiz.pushed = true;
      history.pushState({ quiz: true }, "", url);
      // The new grid arrives in one swap: the line goes above it and the page moves to it; the next swap (another
      // filter, Back) takes the line away again.
      const observer = new MutationObserver(() => {
        observer.disconnect();
        const result = document.createElement("p");
        result.className = "quiz-result";
        result.setAttribute("role", "status");
        result.textContent = line;
        result.hidden = !line;
        grid.before(result);
        (line ? result : grid).scrollIntoView({ block: "start" });
        const gone = new MutationObserver(() => {
          gone.disconnect();
          result.remove();
        });
        gone.observe(grid, { childList: true });
      });
      observer.observe(grid, { childList: true });
      filtering.addFilter(url);
    }
  }
  customElements.define("collection-quiz", CollectionQuiz);
}
